<div class="toolbar-container bottom-toolbar-container box-shadow"
     [class.toolbar-hidden]="isToolbarHidden">
    @for (libBottomToolbarBottomConfig of libBottomToolbarConfig?.libBottomToolbarBottomConfigs; track $index) {
        @switch (libBottomToolbarBottomConfig.type) {
            @case (LibBottomToolbarBottomConfigType.BUTTON) {
                <lib-button [libType]="libBottomToolbarBottomConfig?.buttonType"
                            [libSubType]="libBottomToolbarBottomConfig?.buttonSubType"
                            [iconClass]="libBottomToolbarBottomConfig?.iconClass"
                            [iconPosition]="libBottomToolbarBottomConfig?.iconPosition"
                            [tooltipText]="libBottomToolbarBottomConfig?.tooltip"
                            (buttonClick)="onSubmitLibButton(libBottomToolbarBottomConfig?.id)">
                    @if (libBottomToolbarBottomConfig?.buttonText) {
                        {{ libBottomToolbarBottomConfig?.buttonText }}
                    }
                </lib-button>
            }
            @case (LibBottomToolbarBottomConfigType.CUSTOM) {
                <ng-container
                    [ngTemplateOutlet]="libBottomToolbarBottomConfig.customTemplateRef"></ng-container>
            }
        }
    }
    @if (isLoading) {
        <div class="loading-overlay">
            <div class="spinner"></div>
        </div>
    }
</div>
